const RefreshmentApprovalTypes = {
    REFRESHMENT_APPROVAL_START: 'refreshment_approval_start',
    REFRESHMENT_APPROVAL_SUCCESS: 'refreshment_approval_success',
    REFRESHMENT_APPROVAL_FAILURE: 'refreshment_approval_failure',
    CALCULATE_REFRESHMENT_START: 'calculate_refreshment_start',
    CALCULATE_REFRESHMENT_SUCCESS: 'calculate_refreshment_success',
    CALCULATE_REFRESHMENT_FAILURE: 'calculate_refreshment_failure',
    APPROVE_REFRESHMENT_START: 'approve_refreshment_start',
    APPROVE_REFRESHMENT_SUCCESS: 'approve_refreshment_success',
    APPROVE_REFRESHMENT_FAILURE: 'approve_refreshment_failure',
    BULK_APPROVE_REFRESHMENT_START: 'bulk_approve_refreshment_start',
    BULK_APPROVE_REFRESHMENT_SUCCESS: 'bulk_approve_refreshment_success',
    BULK_APPROVE_REFRESHMENT_FAILURE: 'bulk_approve_refreshment_failure',
    REJECT_REFRESHMENT_START: 'reject_refreshment_start',
    REJECT_REFRESHMENT_SUCCESS: 'reject_refreshment_success',
    REJECT_REFRESHMENT_FAILURE: 'reject_refreshment_failure',
} as const;

export default RefreshmentApprovalTypes; 